<template>
  <div>
    <CRow class="content-fade-in">
      <CCol md="12">
        <CCard>
          <CCardBody>
            <CForm class="form-basic">
              <CRow>
                <CCol sm="6" md="6" xl="6">
                  <BaseInput :options="titleInput.options" :data="titleInput.data" />
                </CCol>

                <CCol sm="6" md="6" xl="6">
                  <div class="form-input-wrapper">
                    <div class="form-group">
                      <label class="form-label" for="uploadFile">Chọn bản tin<span class='required'> *</span></label>
                      <div class="custom-file"
                        :class="selectedFiles.data.validator.isValid == false ? 'input-valid-error' : ''">
                        <input type="file" class="custom-file-input" id="uploadFile" ref="file" :accept="acceptFile"
                          @change="selectFile($event)">
                        <label class="custom-file-label" for="uploadFile">{{ fileName }}
                          <i v-if="selectedFiles.data.loading" class="fa fa-spinner fa-spin"
                            style="position: absolute; right: 100px;font-size: 20px;top: 8px;"></i>
                        </label>
                      </div>
                      <div class="valid-error"
                        v-show="!(selectedFiles.data.validator ? selectedFiles.data.validator.isValid : true)">
                        {{ selectedFiles.data.validator ? selectedFiles.data.validator.errorMessage : "" }}
                      </div>
                    </div>
                  </div>
                </CCol>

                <CCol sm="12" md="12" xl="6">
                  <BaseSelect :options="fileTypeSelect.options" :data="fileTypeSelect.data" ref="fileTypeSelect">
                  </BaseSelect>
                </CCol>

                <CCol sm="12" md="12" xl="6">
                  <BaseSelect :options="levelSelect.options" :data="levelSelect.data" ref="levelSelect">
                  </BaseSelect>
                </CCol>

                <CCol sm="12" md="12" xl="12">
                  <BaseTextArea :options="descriptionInput.options" :data="descriptionInput.data"
                    v-model="descriptionInput.data.model" />
                </CCol>
              </CRow>
              <div slot="footer" class="mt-4">
                <CButton color="primary" class="btn-action-primary mr-2" @click="submitData(false)">
                  <i class="fa fa-save"></i>&nbsp;Lưu lại
                </CButton>
                <CButton color="secondary" class="btn-action-primary" @click="$router.go(-1)"><i class="fa fa-reply"></i>&nbsp;
                  Hủy bỏ
                </CButton>
              </div>
              <BaseLoading :loading="loading.value"></BaseLoading>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue'
import BaseInput from "@/views/base/BaseInput";
import BaseSelect from "@/views/base/BaseSelect2";
import BaseLoading from "@/views/base/BaseFormLoading";
import BaseTextArea from "@/views/base/BaseTextArea";
import { FILE_MAX_SIZE, IS_CHECK_MAX_SIZE_UPLOAD } from "@/constant";

export default {
  name: "FileManagementAdd",
  components: { BaseSelect, BaseInput, BaseLoading, BaseTextArea, VueTimepicker },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Errors"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data: function () {
    let that = this;
    return {
      loading: { value: false },
      fileName: 'Chọn tệp',
      acceptFile: ".mp3 , .wav, .aac, .m4a, .flac, .ogg",
      titleInput: {
        options: {
          label: "Tiêu đề bản tin <span class='required'>*</span>",
          placeholder: "Tiêu đề bản tin",
          maxlength: 200
        },
        data: {
          name: "title",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.titleInput.data.model;
              if (value === "" || value.trim() === "") {
                this.isValid = false;
                this.errorMessage = "Tiêu đề bản tin không được để trống";
              } else {
                this.isValid = true;
              }
              return this.isValid;
            }
          }
        }
      },
      durationInput: {
        data: {
          name: "duration",
          model: null,
        }
      },
      descriptionInput: {
        options: {
          label: "Mô tả bản tin <span class='required'>*</span>",
          placeholder: "Mô tả bản tin",
          maxlength: 2000,
          rows: 5
        },
        data: {
          name: "description",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.descriptionInput.data.model;
              if (value === "" || value.trim() === "") {
                this.isValid = false;
                this.errorMessage = "Mô tả bản tin không được để trống";
              } else {
                this.isValid = true;
              }
              return this.isValid;
            }
          }
        }
      },
      // contentInput: {
      //   options: {
      //     label: "Nội dung bản tin",
      //     placeholder: "Nội dung bản tin",
      //     rows: 5
      //   },
      //   data: {
      //     name: "content",
      //     model: "",
      //     updateCallback: function () {
      //       that.submitData();
      //     },
      //     validator: {
      //       isValid: true,
      //       errorMessage: "",
      //       valid: function () {
      //         let value = that.contentInput.data.model;
      //         if (value == "") {
      //           this.isValid = false;
      //           this.errorMessage = "Nội dung bản tin không được để trống";
      //         } else {
      //           this.isValid = true;
      //           this.errorMessage = "";
      //         }
      //         return this.isValid;
      //       }
      //     }
      //   }
      // },
      selectedFiles: {
        data: {
          loading: false,
          name: "file",
          model: {
            fileName: '',
            content: '',
            size: '',
            type: ''
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              this.isValid = that.validateFile();
              return this.isValid;
            }
          }
        }
      },
      fileTypeSelect: {
        options: {
          filter: true,
          label: "Lĩnh vực <span class='required'>*</span>",
          selectAllText: "Chọn lĩnh vực",
        },
        data: {
          name: "fileTypeId",
          items: [],
          model: "",
          source: {
            url: '/common/listFileType',
            dataSubmit: function () {
              return {}
            },
            response: function (dataResponse) {
              that.fileTypeSelect.data.items = dataResponse.data;
            }
          },
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.fileTypeSelect.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Lĩnh vực bản tin không để trống";
              } else {
                this.isValid = true;
              }
              return this.isValid;
            }
          }
        }
      },
      levelSelect: {
        options: {
          filter: true,
          label: "Mức độ ưu tiên <span class='required'>*</span>",
          selectAllText: "Chọn mức độ ưu tiên",
        },
        data: {
          name: "level",
          items: [
            // {key: '1', value: 'Khẩn cấp'},
            {key: '2', value: 'Ưu tiên'},
            {key: '3', value: 'Thông thường'},
          ],
          model: "",
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.levelSelect.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Mức độ ưu tiên bản tin không để trống";
              } else {
                this.isValid = true;
              }
              return this.isValid;
            }
          }
        }
      },
    }
  },
  methods: {
    submitData: function () {
      let that = this;
      let isValid = true;
      isValid &= this.titleInput.data.validator.valid();
      isValid &= this.selectedFiles.data.validator.valid();
      isValid &= this.fileTypeSelect.data.validator.valid();
      isValid &= this.descriptionInput.data.validator.valid();
      isValid &= this.levelSelect.data.validator.valid();
      if (!isValid) {
        return;
      }

      that.loading.value = true;
      let formData = new FormData();
      formData.append("title", that.titleInput.data.model);
      formData.append("description", that.descriptionInput.data.model);
      formData.append("file", that.$refs.file.files[0]);
      formData.append("duration", that.durationInput.data.model);
      formData.append("fileTypeId", that.fileTypeSelect.data.model);
      formData.append("level", that.levelSelect.data.model);

      that.$helper.loadDataSource({
        url: "/file-management/addFile",
        dataSubmit: function () {
          return formData;
        },
        isMultiPartFormData: true,
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({ message: that.$helper.getStringError(response.data.data) });
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({ message: "Thêm mới bản tin thành công" });
            that.$router.push('/media-management/managed-files.html')
          }
          that.loading.value = false
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
          that.loading.value = false
        }
      });
    },
    selectFile() {
      let that = this;
      let reader = new FileReader();
      let file = this.$refs.file;
      if (file && file.files[0]) {
        file = file.files[0];
        this.selectedFiles.data.loading = true;
        reader.readAsDataURL(file);

        var audio = document.createElement('audio');
        audio.preload = 'metadata';
        audio.onloadedmetadata = function () {
          // window.URL.revokeObjectURL(video.src);
          that.durationInput.data.model = (new Date(audio.duration * 1000).toISOString().substr(11, 8));
        }
        audio.src = URL.createObjectURL(file);

        reader.onload = function () {
          that.fileName = file.name;
          let isValid = that.validateFile(file.type, file.size);
          that.selectedFiles.data.model.size = file.size;
          that.selectedFiles.data.model.fileName = file.name;
          that.selectedFiles.data.model.type = file.type;
          // that.selectedFiles.data.model.content = reader.result.split(',')[1];
        }
        reader.onloadend = function () {
          that.selectedFiles.data.loading = false;
        }
      }
    },
    validateFile(type, size) {
      let isValid = true;
      if ((type && type != undefined) && (size && size != undefined)) {
        isValid = this.validateFileType(type, size);
      } else {
        if (this.selectedFiles.data.model.type && this.selectedFiles.data.model.size) {
          isValid = this.validateFileType(this.selectedFiles.data.model.type, this.selectedFiles.data.model.size);
        } else {
          if (this.selectedFiles.data.model.fileName === '') {
            this.selectedFiles.data.validator.isValid = false;
            this.selectedFiles.data.validator.errorMessage = "Nội dung bản tin không để trống";
            isValid = false;
          }
        }
      }
      return isValid;
    },
    validateFileType(type, size) {
      let isValid = true;
      if (size > FILE_MAX_SIZE && IS_CHECK_MAX_SIZE_UPLOAD) {
        this.selectedFiles.data.validator.isValid = false;
        this.selectedFiles.data.validator.errorMessage = "Tệp tin không được quá 150MB";
        isValid = false;
      } else if (type === "audio/mpeg" || type === "audio/wav" || type === "audio/vnd.dlna.adts" || type == "audio/x-m4a"
        || type == "audio/ogg" || type == "audio/flac" 
        // || type == "audio/x-ms-wma" || type == "audio/aiff"
        ) {
        this.selectedFiles.data.validator.isValid = true;
        this.selectedFiles.data.validator.errorMessage = "";
      } else {
        this.selectedFiles.data.validator.isValid = false;
        this.selectedFiles.data.validator.errorMessage = "Sai định dạng bản tin";
        isValid = false;
      }
      return isValid;
    }
  },
  computed: {},
  created() {
  },
  mounted() {
  },
  watch: {}
}
</script>
<style></style>
